// Brand mark, avatar, stat card and a dependency-free SVG bar chart.
import { html, raw, escapeHtml } from '../utilities/html.js';
import { icon } from '../utilities/icons.js';
import { brand } from '../brand.js';

export function brandMark(size = 36) {
  return html`<span class="brand-mark" style="width:${size}px;height:${size}px"><img src="${brand.logoSrc}" alt="${brand.logoAlt}" width="${size}" height="${size}"></span>`;
}

export function initials(name = '', email = '') {
  const source = (name || email || '?').trim();
  const parts = source.split(/[\s@._-]+/).filter(Boolean);
  return ((parts[0]?.[0] ?? '?') + (parts.length > 1 ? parts[1][0] : '')).toUpperCase();
}

export function avatar(name, email, size = '') {
  return html`<span class="avatar ${size ? `avatar--${size}` : ''}" aria-hidden="true">${initials(name, email)}</span>`;
}

export function statCard({ label, value, hint = '', iconName = 'dashboard' }) {
  return html`<div class="card stat-card">
    <div class="stat-card__icon">${icon(iconName)}</div>
    <div class="stat-card__label">${label}</div>
    <div class="stat-card__value">${value}</div>
    ${hint ? html`<div class="stat-card__hint">${hint}</div>` : ''}
  </div>`;
}

/** Horizontal bar chart. data: [{ label, value }] */
export function barChart(data, { title = 'Chart', rowHeight = 30, labelWidth = 150, width = 560 } = {}) {
  const max = Math.max(1, ...data.map((d) => d.value));
  const height = data.length * rowHeight + 8;
  const barArea = width - labelWidth - 40;
  const rows = data.map((d, i) => {
    const y = i * rowHeight + 4;
    const w = Math.max(2, (d.value / max) * barArea);
    return `<text x="0" y="${y + rowHeight / 2 + 4}">${escapeHtml(d.label)}</text>
      <rect class="chart__bar" x="${labelWidth}" y="${y + 6}" width="${w.toFixed(1)}" height="${rowHeight - 12}" rx="5"><title>${escapeHtml(d.label)}: ${d.value}</title></rect>
      <text class="chart__value" x="${(labelWidth + w + 8).toFixed(1)}" y="${y + rowHeight / 2 + 4}">${d.value}</text>`;
  }).join('');
  return raw(`<svg class="chart" viewBox="0 0 ${width} ${height}" role="img" aria-label="${escapeHtml(title)}">
    <line class="chart__grid" x1="${labelWidth}" x2="${labelWidth}" y1="0" y2="${height}"/>${rows}</svg>`);
}
